import React, { useContext, useEffect, useRef, useState } from "react";

import swal from "sweetalert";
import { Badge, Button } from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { useQuery } from "../../utils/useQuery";
import { sendEmail } from "../emailApi";
const Approvalleave = () => {
  const [activeTab, setActiveTab] = useState("tab1");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <div className="mt-4">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "tab1" ? "active" : ""}`}
              style={activeTab === "tab1" ? { border: "" } : {}}
              onClick={() => handleTabClick("tab1")}
            >
              Leave Approval
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "tab2" ? "active" : ""}`}
              style={activeTab === "tab2" ? { border: "" } : {}}
              onClick={() => handleTabClick("tab2")}
            >
              WFH Approval
            </button>
          </li>
        </ul>
        <div className="tab-content p-3">
          {activeTab === "tab1" && <LeaveApprovalAdmin />}
          {activeTab === "tab2" && <Wfhapproval />}
        </div>
      </div>
    </>
  );
};

const LeaveApprovalAdmin = () => {
  const formatEmailDate = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  const query = useQuery();
  const id = query.get("id");
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [Employeeid, setEmployeeid] = useState(-1);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const { password, username } = billpunchbasicauth;
  const [employeeData, setEmployeeData] = useState([]);
  const getEmployeebirthday = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const res = await fetch(`${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployee`, {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ firmId: user.firm_id }),
      });

      const data = await res.json();

      if (data.status === "0" && Array.isArray(data.data)) {
        setEmployeeData(data.data);
      } else {
        console.warn("No valid employee data returned from API");
        setEmployeeData([]);
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
      setEmployeeData([]);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const getEmployeeEmailByEmpId = (empId) => {
    const employee = employeeData.find((emp) => String(emp.empid) === String(empId));
    return employee?.work_email || null;
  };

  const GetAllEmployeeLeave = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmid: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetAllEmployeeLeave`,
        requestOptions
      );
      const data1 = await res.json();
      if (data1.status === "0") {
        setData1(data1.data);
        filterDataForMonth(new Date(), data1.data);
        if (data1.data.length > 0) {
          setEmployeeid(data.data[0].id);
        }
      }
      console.log(data, "hiiiii");
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const ApproveRejectLeave = async (
    empId,
    employeeName,
    leaveId,
    status,
    formDate,
    toDate,
    leave_category,
    attstatus
  ) => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const parsedFormDate = new Date(formDate);
  
      const formatDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };
  
      const formattedFormDate = formatDate(formDate);
      const formattedToDate = formatDate(toDate);
  
      let leaveType;
      if (leave_category === "Sick") {
        leaveType = "SL";
      } else if (
        leave_category === "Casual" ||
        leave_category === "Out of station"
      ) {
        leaveType = "PL";
      } else {
        leaveType = leave_category;
      }
  
      const raw = JSON.stringify({
        empid: String(empId),
        name: String(employeeName),
        leaveid: String(leaveId),
        status: String(status),
        approved_by: String(user.userid),
        fromdate: formattedFormDate,
        todate: formattedToDate,
        type: leaveType,
        attstatus: String(attstatus),
        month: String(parsedFormDate.getMonth() + 1),
        year: String(parsedFormDate.getFullYear()),
        firmid: String(user.firm_id),
      });
  
      console.log("Sending request:", raw);
  
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/ApproveRejectLeave`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: raw,
        }
      );
  
      const data = await res.json();
      console.log("API response:", data);
  
      GetAllEmployeeLeave();
  
      if (data.status === "1") {
        swal("Error", data.result, "error");
        return false;
      } else {
        swal("Success", data.result, "success");
        return true;
      }
    } catch (error) {
      console.log("Error in ApproveRejectLeave:", error);
      return false;
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const handleApprove = async (leaveId) => {
    console.log("handleApprove called for leaveId:", leaveId);
  
    // Find the selected leave
    const selectedLeave = data1.find((item) => item.pk_leave_id === leaveId);
    console.log("Selected leave:", selectedLeave);
  
    if (!selectedLeave) {
      console.warn("No leave found for leaveId:", leaveId);
      return;
    }
  
    // Get employee email
    const employeeEmail = getEmployeeEmailByEmpId(selectedLeave.empid);
    console.log("Employee email found:", employeeEmail);
  
    if (!employeeEmail) {
      console.warn("No email found for employeeId:", selectedLeave.empid);
      return;
    }
  
    // Call the API
    console.log("Calling ApproveRejectLeave API...");
    const approved = await ApproveRejectLeave(
      selectedLeave.empid,
      selectedLeave.employee_name,
      selectedLeave.pk_leave_id,
      "A",
      selectedLeave.form_date,
      selectedLeave.to_date,
      selectedLeave.leave_category,
      "Y"
    );
    console.log("Leave approval response:", approved);
  
    if (!approved) {
      console.warn("Leave approval failed for leaveId:", leaveId);
      return;
    }
  
    // Send email
    console.log("Sending approval email...");
    try {
      await sendEmail({
        to: [employeeEmail],
        triggerId: "TR-8cb18ac0f1f111f0b89542010aa0000f",
        variables: {
          employee_name: selectedLeave.employee_name,
          leave_type: selectedLeave.leave_category,
          start_date: formatEmailDate(selectedLeave.form_date),
          end_date: formatEmailDate(selectedLeave.to_date),
          reason: selectedLeave.leave_description || "N/A",
        },
      });
      console.log("Approval email sent successfully to:", employeeEmail);
    } catch (emailError) {
      console.error("Error sending approval email:", emailError);
    }
  };
  
  const handleReject = async (leaveId) => {
    console.log("handleReject called for leaveId:", leaveId);
  
    // Find the selected leave
    const selectedLeave = data1.find((item) => item.pk_leave_id === leaveId);
    console.log("Selected leave:", selectedLeave);
  
    if (!selectedLeave) {
      console.warn("No leave found for leaveId:", leaveId);
      return;
    }
  
    // Get employee email
    const employeeEmail = getEmployeeEmailByEmpId(selectedLeave.empid);
    console.log("Employee email found:", employeeEmail);
  
    if (!employeeEmail) {
      console.warn("No email found for employeeId:", selectedLeave.empid);
      return;
    }
  
    // Call the API
    console.log("Calling ApproveRejectLeave API for rejection...");
    const rejected = await ApproveRejectLeave(
      selectedLeave.empid,
      selectedLeave.employee_name,
      selectedLeave.pk_leave_id,
      "R",
      selectedLeave.form_date,
      selectedLeave.to_date,
      selectedLeave.leave_category,
      "N"
    );
    console.log("Leave rejection response:", rejected);
  
    if (!rejected) {
      console.warn("Leave rejection failed for leaveId:", leaveId);
      return;
    }
  
    try {
      await sendEmail({
        to: [employeeEmail],
        triggerId: "TR-90c91308f1f111f0b89542010aa0000f",
        variables: {
          employee_name: selectedLeave.employee_name,
          leave_type: selectedLeave.leave_category,
          start_date: formatEmailDate(selectedLeave.form_date),
          end_date: formatEmailDate(selectedLeave.to_date),
          reason: selectedLeave.leave_description || "N/A",
          status: "Rejected",
        },
      });
    } catch (emailError) {
      console.error("Error sending rejection email:", emailError);
    }
  };
  
  const filterDataForMonth = (date, data) => {
    const selectedMonth = date.getMonth();
    const selectedYear = date.getFullYear();

    const filtered = data.filter((item) => {
      const formDate = new Date(item.form_date);
      return (
        formDate.getMonth() === selectedMonth &&
        formDate.getFullYear() === selectedYear
      );
    });

    setFilteredData(filtered);
  };
  const handleDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    setSelectedDate(selectedDate);
    filterDataForMonth(selectedDate, data1);
  };

  useEffect(() => {
    GetAllEmployeeLeave();
  }, [Employeeid]);
  const { accessData } = useContext(GlobalContext);
  useEffect(() => {
    getEmployeebirthday(); 
  }, []);
  return (
    <>
      <div
      // className="d-flex justify-content-center align-items-center"
      // style={{ minHeight: "30px" }}
      >
        <div className="mb-2 d-flex">
          <label
            htmlFor="month-picker"
            className="form-label"
            style={{ width: "9rem" }}
          >
            Select Month:
          </label>
          <input
            type="month"
            id="month-picker"
            className="form-control"
            value={`${selectedDate.getFullYear()}-${String(
              selectedDate.getMonth() + 1
            ).padStart(2, "0")}`}
            onChange={handleDateChange}
            style={{ width: "12rem" }}
          />
        </div>

        <table
          className="PMS-collection-table "
          style={{
            textAlign: "center",
            overflow: "hidden",
            borderRadius: ".4rem",
          }}
        >
          <thead>
            <tr>
              <th style={{ color: "#0074D9" }}>Name</th>
              <th style={{ color: "#0074D9" }}>Category</th>
              <th style={{ color: "#0074D9" }}>Reason</th>
              <th style={{ color: "#0074D9" }}>From</th>
              <th style={{ color: "#0074D9" }}> ToDate </th>
              <th style={{ color: "#0074D9" }}>Status</th>
              <th style={{ color: "#0074D9" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                <td
                  className="px-2"
                  colSpan="7"
                  style={{ textAlign: "center" }}
                >
                  No data found
                </td>
              </tr>
            ) : (
              filteredData.map((item) => (
                <tr key={item.pk_leave_id}>
                  <td>{item.employee_name}</td>
                  <td>{item.leave_category}</td>
                  <td>{item.leave_description}</td>
                  <td>{new Date(item.form_date).toLocaleDateString()}</td>
                  <td>{new Date(item.to_date).toLocaleDateString()}</td>
                  <td>
                    {item.status === "R" && (
                      <span
                        className="p-1"
                        style={{
                          backgroundColor: "rgba(255, 46, 46, 0.1)",
                          color: "#ff2e2e",
                          border: "1px solid #ff2e2e",
                          borderRadius: ".3rem",
                        }}
                      >
                        Rejected
                      </span>
                    )}
                    {item.status === "P" && (
                      <span
                        className="p-1"
                        style={{
                          backgroundColor: "rgba(255, 255, 0, 0.1)",
                          color: " #f7b12a",
                          border: "1px solid #f7b12a",
                          borderRadius: ".3rem",
                        }}
                      >
                        Pending
                      </span>
                    )}
                    {item.status === "A" && (
                      <span
                        className="p-1"
                        style={{
                          backgroundColor: "rgba(43, 193, 85, 0.1)",
                          color: "#2bc155",
                          border: "1px solid #2bc155",
                          borderRadius: ".3rem",
                        }}
                      >
                        Approved
                      </span>
                    )}
                  </td>

                  <td>
                    <div className="d-flex justify-content-around align-items-center">
                      <button
                        type="button"
                        className="btn btn-sm btn-success d-flex justify-content-center align-items-center"
                        style={{
                          height: "2rem",
                          borderRadius: ".3rem",
                        }}
                        onClick={() => handleApprove(item.pk_leave_id)}
                        disabled={item.status !== "P"}
                      >
                        Approve
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-danger d-flex justify-content-center align-items-center"
                        style={{
                          height: "2rem",
                          borderRadius: ".3rem",
                        }}
                        onClick={() => handleReject(item.pk_leave_id)}
                        disabled={item.status !== "P"}
                      >
                        Reject
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};
const Wfhapproval = () => {
  const query = useQuery();
  const id = query.get("id");
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [data1, setData1] = useState([]);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const formatWfhDate = (date) => {
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, "0")}-${String(
      d.getMonth() + 1
    ).padStart(2, "0")}-${d.getFullYear()}`;
  };
  const { password, username } = billpunchbasicauth;
  const getwfh = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        empid: "string",
        firmid: user.firm_id,
        reporting_id: user.userid,
        type: "2",
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetWfhV1`,
        requestOptions
      );
      const data1 = await res.json();
      if (data1.status === "0") {
        setData1(data1.data);
        filterDataForMonth(new Date(), data1.data);
      }
      console.log(data, "hiiiii");
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const handleAction = async (item, action) => {
    try {
      setTransactionLoaderState(true);
      const base64Credentials = btoa(`${username}:${password}`);
      const approveRes = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/ApproveWorkFromHomeV1`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            homeid: item.pk_id,
            status: action,
            empid: item.empid,
            name: item.fullname,
          }),
        }
      );
      const approveData = await approveRes.json();
      if (approveData.status === "1") {
        swal("Error", approveData.result, "error");
        getwfh();
        return;
      }
      swal("Success", approveData.result, "success");
      getwfh();
      const empRes = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployee`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ firmId: user.firm_id }),
        }
      );
      const empData = await empRes.json();
      if (empData.status !== "0" || !empData.data?.length) {
        console.error("Cannot fetch employee data");
        return;
      }
      const employee = empData.data.find(emp => String(emp.empid) === String(item.empid));
    
      try {
        const emailResponse = await sendEmail({
          to: [employee.work_email],
          triggerId:
            action === "Y"
              ? "TR-a49f9acdf1f111f0b89542010aa0000f"
              : "TR-a9430cf2f1f111f0b89542010aa0000f",
          variables: {
            employee_name: item.fullname,
            wfh_date: formatWfhDate(item.date),
          },
        });
     } catch (emailError) {
        console.error("Error sending email:", emailError);
      }
    } catch (error) {
      console.error("handleAction error:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const filterDataForMonth = (date, data) => {
    const selectedMonth = date.getMonth();
    const selectedYear = date.getFullYear();

    const filtered = data.filter((item) => {
      const formDate = new Date(item.date);
      return (
        formDate.getMonth() === selectedMonth &&
        formDate.getFullYear() === selectedYear
      );
    });

    setFilteredData(filtered);
  };
  const handleDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    setSelectedDate(selectedDate);
    filterDataForMonth(selectedDate, data1);
  };
  useEffect(() => {
    getwfh();
  }, []);
  return (
    <>
      <div className="">
        <div className="mb-2 d-flex">
          <label
            htmlFor="month-picker"
            className="form-label"
            style={{ width: "9rem" }}
          >
            Select Month:
          </label>
          <input
            type="month"
            id="month-picker"
            className="form-control"
            value={`${selectedDate.getFullYear()}-${String(
              selectedDate.getMonth() + 1
            ).padStart(2, "0")}`}
            onChange={handleDateChange}
            style={{ width: "12rem" }}
          />
        </div>
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "30px" }}
        >
          <table
            className="PMS-collection-table m-1"
            style={{
              textAlign: "center",
              overflow: "hidden",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    color: "#0074D9",
                    border: "1px solid #cccccc",
                    padding: "8px",
                  }}
                >
                  Sr.
                </th>
                <th
                  style={{
                    color: "#0074D9",
                    border: "1px solid #cccccc",
                    padding: "8px",
                  }}
                >
                  {" "}
                  Employee{" "}
                </th>
                <th
                  style={{
                    color: "#0074D9",
                    border: "1px solid #cccccc",
                    padding: "8px",
                  }}
                >
                  {" "}
                  Reason{" "}
                </th>
                <th
                  style={{
                    color: "#0074D9",
                    border: "1px solid #cccccc",
                    padding: "8px",
                  }}
                >
                  Date
                </th>

                <th
                  style={{
                    color: "#0074D9",
                    border: "1px solid #cccccc",
                    padding: "8px",
                  }}
                >
                  Reporting Person
                </th>
                <th
                  style={{
                    color: "#0074D9",
                    border: "1px solid #cccccc",
                    padding: "8px",
                  }}
                >
                  Status
                </th>
                <th
                  style={{
                    color: "#0074D9",
                    border: "1px solid #cccccc",
                    padding: "8px",
                  }}
                >
                  Login status
                </th>
                <th
                  style={{
                    color: "#0074D9",
                    border: "1px solid #cccccc",
                    padding: "8px",
                  }}
                >
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {filteredData.length === 0 ? (
                <tr>
                  <td
                    colSpan="5"
                    style={{ textAlign: "center", border: "none" }}
                  >
                    No data found
                  </td>
                </tr>
              ) : (
                filteredData.map((item, index) => (
                  <tr key={item.empid}>
                    <td
                      style={{
                        border: "1px solid #cccccc",
                        padding: "8px",
                      }}
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{
                        borderRight: "1px solid #cccccc",
                        padding: "8px",
                      }}
                    >
                      {item.fullname}
                    </td>
                    <td
                      style={{
                        borderRight: "1px solid #cccccc",
                        padding: "8px",
                      }}
                    >
                      {item.reason}
                    </td>
                    <td
                      style={{
                        borderRight: "1px solid #cccccc",
                        padding: "8px",
                      }}
                    >
                      {item.date}
                    </td>
                    <td
                      style={{
                        borderRight: "1px solid #cccccc",
                        padding: "8px",
                      }}
                    >
                      {item.reporting_name}
                    </td>

                    <td style={{ padding: "8px" }}>
                      {item.status === "R" && (
                        <span
                          className="p-1"
                          style={{
                            backgroundColor: "rgba(255, 46, 46, 0.1)",
                            color: "#ff2e2e",
                            border: "1px solid #ff2e2e",
                            borderRadius: ".3rem",
                          }}
                        >
                          Rejected
                        </span>
                      )}
                      {item.status === "N" && (
                        <span
                          className="p-1"
                          style={{
                            backgroundColor: "rgba(255, 255, 0, 0.1)",
                            color: "#f7b12a",
                            border: "1px solid #f7b12a",
                            borderRadius: ".3rem",
                          }}
                        >
                          Pending
                        </span>
                      )}
                      {item.status === "Y" && (
                        <span
                          className="p-1"
                          style={{
                            backgroundColor: "rgba(43, 193, 85, 0.1)",
                            color: "#2bc155",
                            border: "1px solid #2bc155",
                            borderRadius: ".3rem",
                          }}
                        >
                          Approved
                        </span>
                      )}
                    </td>
                    <td
                      style={{
                        color: "#0074D9",
                        border: "1px solid #cccccc",
                        padding: "8px",
                      }}
                    >
                      {item.login_status === "N" &&
                      item.logout_status === "N" ? (
                        <div
                          className="btn-sm"
                          style={{
                            backgroundColor: "rgba(43, 193, 85, 0.1)",
                            color: "#2bc155",
                            border: "1px solid #2bc155",
                            borderRadius: ".3rem",
                            fontSize: ".8rem",
                          }}
                        >
                          Yet to Login
                        </div>
                      ) : item.login_status === "Y" &&
                        item.logout_status === "N" ? (
                        <div
                          className="btn-sm"
                          style={{
                            backgroundColor: "rgba(43, 193, 85, 0.1)",
                            color: "#2bc155",
                            border: "1px solid #2bc155",
                            borderRadius: ".3rem",
                            fontSize: ".8rem",
                          }}
                        >
                          Logged In
                        </div>
                      ) : item.login_status === "Y" &&
                        item.logout_status === "Y" ? (
                        <div
                          className="btn-sm"
                          style={{
                            backgroundColor: "rgba(43, 193, 85, 0.1)",
                            color: "#2bc155",
                            border: "1px solid #2bc155",
                            borderRadius: ".3rem",
                            fontSize: ".8rem",
                          }}
                        >
                          Approval Pending
                        </div>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td
                      style={{
                        borderRight: "1px solid #cccccc",
                        padding: "8px",
                      }}
                    >
                      <Button
                        variant="success"
                        size="sm"
                        className="mr-2"
                        onClick={() => handleAction(item, "Y")}
                        disabled={item.status === "Y" || item.status === "R"}
                      >
                        Approve
                      </Button>
                      &nbsp;&nbsp;
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleAction(item, "R")}
                        disabled={item.status === "Y" || item.status === "R"}
                      >
                        Reject
                      </Button>
                      &nbsp;&nbsp;
                      <Link to="/Hr/Review-Wfh">
                        <FaArrowRight
                          variant="info"
                          onClick={() => {
                            sessionStorage.setItem(
                              "WFHwork",
                              JSON.stringify(item)
                            );
                          }}
                        />
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
export default Approvalleave;
